// extracted by mini-css-extract-plugin
export default {"domain_wrapper":"Domain_domain_wrapper__BVP0L","bgname":"Domain_bgname__pNYaW","domain_text":"Domain_domain_text__CZZV0","domain_container":"Domain_domain_container__xavkR"};